module.exports = __webpack_public_path__ + "static/media/que-hacer-en-la-boca.2a3895ad.md";